import { DataType } from '@common/enums/data-type';
import { KnownPropertyTypes } from '@common/enums/known-property-types';
import { IGenericAccessor } from '@common/interfaces/i-generic-accessor';

const metaData = {
    Approved: DataType.BOOL,
    BeginText: DataType.STRING,
    ContainerTitle: DataType.STRING,
    ContainerModTime: DataType.DATE,
    Creator: DataType.STRING,
    ENPSDatabase: DataType.STRING,
    Expires: DataType.DATE,
    FileStorageVersion: DataType.NUMBER,
    Guid: DataType.STRING,
    ModBy: DataType.STRING,
    ModTime: DataType.DATE,
    MosControl: DataType.BOOL,
    MosObjId: DataType.STRING,
    OutputType: DataType.NUMBER,
    Owner: DataType.STRING,
    Path: DataType.STRING,
    Priority: DataType.NUMBER,
    Title: DataType.STRING,
    Type: DataType.NUMBER,
};

KnownPropertyTypes.setFor(metaData);
export const ListDataMetaData = metaData;
export class ListData implements IGenericAccessor {
    public Approved?: boolean;
    public BeginText?: string;
    public ContainerTitle?: string;
    public ContainerModTime?: string;
    public Creator?: string;
    public ENPSDatabase?: string;
    public Expires?: string;
    public FileStorageVersion?: number;
    public Guid?: string;
    public ModBy?: string;
    public ModTime?: string;
    public MosControl?: true;
    public MosObjId?: string;
    public OutputType?: number;
    public Owner?: string;
    public Path?: string;
    public Priority?: number;
    public Title?: string;
    public Type?: number;

    public getMetaData(): { [id: string]: number } {
        const keys = Object.keys(this);
        const ret: { [id: string]: number } = {};
        for (const prop of keys) {
            if (metaData[prop]) ret[prop] = metaData[prop];
        }
        return ret;
    }

    public getRawValue(field: string): any {
        return this[field];
    }
}
